class PaymentGatewayVisitedDirective {
    constructor($document, $rootScope, $window, $http) {
        this.restrict = 'A';
        this.$document = $document;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$http = $http;
    }

    link(scope, element, attrs) {

        const orderData = attrs.paymentGatewayVisited.split(',');
        this.orderId = orderData[0];
        this.token = orderData[1];

        if (element[0].nodeName.toLowerCase() === 'form') {
            const onSubmit = (e) => {
                this.submit();
            };
            element.on('submit', onSubmit);
        } else {
            const onClick = (e) => {
                this.submit();
            };
            element.on('click', onClick);
        }
    }

    submit() {
        this.$http.post('/ajax/orders/setPaymentGatewayVisitedStatus', {
            orderId: this.orderId,
            token: this.token
        }).then((response) => {
        });
    }

    static directiveFactory($document, $rootScope, $window, $http) {
        'ngInject';
        return new PaymentGatewayVisitedDirective($document, $rootScope, $window, $http);
    }
}

export default PaymentGatewayVisitedDirective;
